
var Model = require("../types/Model.js");

module.exports = Model({
	name: "privacypolicy",
	init: init,
	triggers: triggers,

});

function triggers() {
	return {
		"show": show,
		"hide": hide,
	};
}
function init() {
	this.push(false);
}

function show(){
	this.push(true);
	this.emit("usermetrics:trigger:track", "view aetonix privacy policy");
}

function hide(){
	this.push(false);
	this.emit("usermetrics:trigger:track", "close aetonix privacy policy");
}